module.exports = __webpack_public_path__ + "img/li.104f3781.png";